import { Client, GiftKycAmc } from "creso-core/types";

export type OccupationType = string;

export interface GiftKycFormData {
  amc: GiftKycAmc;
  /** The client the KYC is being filled for; null until one is picked. */
  selectedClient: Client | null;
  maskedAadhaar: File | string | null;
  panCard: File | string | null;
  cancelledCheque: File | string | null;
  /** Passwords for uploaded documents that are password-protected PDFs */
  maskedAadhaarPassword?: string;
  panCardPassword?: string;
  cancelledChequePassword?: string;
  ckycNumber: string;
  fatherName: string;
  occupationType: string;
  companyName: string;
  companyAddress: string;
  natureOfBusiness: string;
  agreedToTerms: boolean;
  formSigned?: boolean;
  responseForm?: string;
  formId?: number;
}

export const INITIAL_FORM_DATA: GiftKycFormData = {
  amc: "PPFAS",
  selectedClient: null,
  fatherName: "",
  maskedAadhaar: null,
  panCard: null,
  cancelledCheque: null,
  ckycNumber: "",
  occupationType: "",
  companyName: "",
  companyAddress: "",
  natureOfBusiness: "",
  agreedToTerms: false,
};

export interface StepProps {
  formData: GiftKycFormData;
  onNext: (data: Partial<GiftKycFormData>) => void;
  onBack: () => void;
}
